import { lazyNamed } from 'src/utils/lazyNamed.ts';

export default {
  DealGroupDeals: lazyNamed(() => import('./pages/DealGroupDeals/index.tsx'), 'DealGroupDeals'),
  DealGroupDealsheet: lazyNamed(() => import('./pages/DealGroupDealsheet/index.tsx'), 'DealGroupDealsheet'),
  DealGroupForm: lazyNamed(() => import('./pages/DealGroupForm/index.tsx'), 'DealGroupForm'),
  DealGroups: lazyNamed(() => import('./pages/DealGroups/index.tsx'), 'DealGroups'),
  Deals: lazyNamed(() => import('./pages/Deals/index.tsx'), 'Deals'),
  Helmet: lazyNamed(() => import('./components/Helmet.tsx'), 'Helmet'),
  Reporting: lazyNamed(() => import('./pages/Reporting/index.tsx'), 'Reporting'),
};
